import thunkMiddleware from 'redux-thunk';
import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';

import rootReducer from './RootReducer';

const middlewares = [thunkMiddleware];

const composeEnhancers = composeWithDevTools({
  // Specify name here, actionsBlacklist, actionsCreators and other options if needed
});

export default  createStore(
  rootReducer,
  {},
  composeEnhancers(applyMiddleware(...middlewares)),
);


// WEBPACK FOOTER //
// ./src/app/Store.js